export default "__VITE_ASSET__D2vw1Lmk__"